import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'mp-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrl: './navigation-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'mp-navigation-item',
    '[class.mp-navigation-item--parent]': 'isParentItem()',
    '[class.mp-navigation-item--child]': 'isChildItem()',
    '[class.mp-navigation-item--expanded]': 'isExpanded()',
  },
  imports: [RouterLink, RouterLinkActive, MatIcon, MatRipple],
})
export class NavigationItemComponent {
  readonly icon: InputSignal<string> = input.required<string>();
  readonly path: InputSignal<string> = input.required<string>();
  readonly label: InputSignal<string> = input<string>('');

  /**
   * Indicates if the item is a parent item (has children).
   */
  readonly isParentItem: InputSignal<boolean> = input<boolean>(false);

  /**
   * Indicates if the item is a child item.
   */
  readonly isChildItem: InputSignal<boolean> = input<boolean>(false);

  /**
   * Indicates if the item is expanded.
   */
  readonly isExpanded: InputSignal<boolean> = input<boolean>(false);

  readonly itemClick: OutputEmitterRef<void> = output<void>();

  emitItemClick(): void {
    this.itemClick.emit();
  }
}
